import {
  DateField,
  List,
  ListProps,
  TextInput,
  number,
  useRecordContext,
  Datagrid,
  EditButton,
  ShowButton,
  FieldProps,
  RaRecord,
  Link,
} from "react-admin";
import { StandardPagination } from "../../common/StandardPagination";

interface JobApplicationRecord extends RaRecord {
  applicant?: {
    userId?: number;
    user?: {
      fullName?: string;
    };
  };
  offer?: {
    id?: number;
    title?: string;
  };
}

const UsersURLField = (props: FieldProps) => {
  const record = useRecordContext<JobApplicationRecord>(props);
  if (!record?.applicant?.userId) {
    return null;
  }
  return (
    <Link to={`/users/${record.applicant.userId}/show`}>
      {record.applicant.user?.fullName || "N/A"}
    </Link>
  );
};

const OfferURLField = (props: FieldProps) => {
  const record = useRecordContext<JobApplicationRecord>(props);
  if (!record?.offer?.id) {
    return null;
  }
  return (
    <Link to={`/job-offers/${record.offer.id}/show`}>
      {record.offer.title || "N/A"}
    </Link>
  );
};

export const ListJobApplications: React.FC<ListProps> = (props) => {
  const filters = [
    <TextInput
      key="reference"
      label="Referencia"
      source="reference"
      validate={number()}
      alwaysOn
    />,

    <TextInput key="applicant" label="Usuario" source="fullName" alwaysOn />,
  ];

  return (
    <List
      {...props}
      perPage={10}
      filters={filters}
      sort={{ field: "createdAt", order: "DESC" }}
      pagination={<StandardPagination />}
    >
      <Datagrid optimized>
        <OfferURLField label="Oferta" />
        <UsersURLField label="Usuario" />
        <DateField source="createdAt" label="Fecha de postulación" />
        <ShowButton label="Ver" />
        <EditButton label="Editar" />
      </Datagrid>
    </List>
  );
};
